import { generateTestId } from "@client-shared";

export const setRoasterProfileSelectorTestId = (identifier: string): string =>
  generateTestId("RoasterProfileSelector", identifier);
